import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { STR_DISTRICT, STR_REGION, STR_STREET, STR_WARD } from "../Strings";
import { MdLocationPin } from "react-icons/md";

export default function NapaAddressPicker({ title, callback }) {
	const appContext = useContext(AppContext);

		const [loading, setLoading] = useState(false);

	const [region, setRegion] = useState("");
  const [district, setDistrict] = useState("");
	const [ward, setWard] = useState("");
	const [street, setStreet] = useState("");
	const [regionId, setRegionId] = useState(null);
  const [districtId, setDistrictId] = useState(null);
	const [wardId, setWardId] = useState(null);
	const [streetId, setStreetId] = useState(null);

	const [allRegions, setAllRegions] = useState(null);
	const [allDistricts, setAllDistricts] = useState(null);
	const [allWards, setAllWards] = useState(null);
	const [allStreets, setAllStreets] = useState(null);
	
	async function init() {
			appContext.getRegions().then((_regions) => {
	      setAllRegions(_regions);
	    })
	}

	async function handleRegionChange() {
    if (region && allRegions) {
      //reset district selection
      setAllDistricts(null);
      setDistrict("");
			setDistrictId(null);

			setAllWards(null);
			setWard('');
			setWardId(null);

			setAllStreets(null);
			setStreet('');
			setStreetId(null);

      //set regionId
      let _regionId = null;

      for (const _region of allRegions) {
        if (_region.name === region) {
          _regionId = _region.id;
          break;
        }
      }

      if (_regionId) {
        //get districts
				setRegionId(_regionId);
        setLoading(true);
        await appContext.getDistricts({ regionId: _regionId }).then(_districts => {
          setAllDistricts(_districts);
        })
        setLoading(false);
      }
    }
  }

	async function handleDistrictChange() {
    if (district && allDistricts) {
      //reset ward selection
      setAllWards(null);
			setWard('');
			setWardId(null);

			setAllStreets(null);
			setStreet('');
			setStreetId(null);

      //set districtId
      let _districtId = null;

      for (const _district of allDistricts) {
        if (_district.name === district) {
          _districtId = _district.id;
          break;
        }
      }

      if (_districtId) {
        //get districts
        setLoading(true);
				setDistrictId(_districtId);
        await appContext.getWards({ districtId: _districtId }).then(_wards => {
          setAllWards(_wards);
        })
        setLoading(false);
      }
    }
  }

	async function handleWardChange() {
    if (ward && allWards) {
      //reset ward selection
      setAllStreets(null);
			setStreet('');
			setStreetId(null);

      //set districtId
      let _wardId = null;

      for (const _ward of allWards) {
        if (_ward.name === ward) {
          _wardId = _ward.id;
          break;
        }
      }

      if (_wardId) {
        //get districts
        setLoading(true);
				setWardId(_wardId);
        await appContext.getStreets({ wardId: _wardId }).then(_streets => {
          setAllStreets(_streets);
        })
        setLoading(false);
      }
    }
  }

	async function handleStreetChange() {
    if (street && allStreets) {
     
      let _streetId = null;

      for (const _street of allStreets) {
        if (_street.name === street) {
          _streetId = _street.id;
          break;
        }
      }

      if (_streetId) {
        setStreetId(_streetId);
      }
    }
  }

	useEffect(() => {
		init();
	}, [ ])

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])

	useEffect(() => {
		handleRegionChange();
	}, [ region ])

	useEffect(() => {
		handleDistrictChange();
	}, [ district ])

	useEffect(() => {
		handleWardChange();
	}, [ ward ])

	useEffect(() => {
		handleStreetChange();
	}, [ street ])

	useEffect(() => {
		if(callback) {
			const _address = {
				region,
				regionId,
				district,
				districtId,
				ward,
				wardId,
				street,
				streetId,
			};

			callback(_address);
		}
	}, [ region, regionId, district, districtId, ward, wardId, street, streetId, ])


	return (
		<div
			className="card"
		>
			
			<div className="card-body">
				<h6
					className="font-regular text-center text-muted"
					style={{
						fontSize: "24px"
					}}
				>
					<MdLocationPin size={48}/>
					
				</h6>

				<div className="row">
					<div className="col-6 mt-1 mb-1">
						<label style={{ fontSize: "12px" }} className="form-label">{STR_REGION[appContext.language]}</label>
						<select
							className="form-control"
							onChange={(e) => {
								setRegion(e.target.value)
							}}
							value={region}
						>
							<option value=""></option>
							{
								(allRegions && allRegions.length > 0) ?
									allRegions.map((item, i) => {
										return (
											<option key={i} value={item.name}>{item.name}</option>
										)
									})
									: ""
							}
						</select>
					</div>

					<div className="col-6 mt-1 mb-1">
						<label className="form-label" style={{ fontSize: "12px" }}>{STR_DISTRICT[appContext.language]}</label>
						<select
							className="form-control"
							onChange={(e) => {
								setDistrict(e.target.value)
							}}
							value={district}
						>
							<option value=""></option>
							{
								(allDistricts && allDistricts.length > 0) ?
									allDistricts.map((item, i) => {
										return (
											<option key={i} value={item.name}>{item.name}</option>
										)
									})
									: ""
							}
						</select>
					</div>

					<div className="col-6 mt-1 mb-1">
						<label className="form-label" style={{ fontSize: "12px" }}>{STR_WARD[appContext.language]}</label>
						<select
							className="form-control"
							onChange={(e) => {
								setWard(e.target.value)
							}}
							value={ward}
						>
							<option value=""></option>
							{
								(allWards && allWards.length > 0) ?
									allWards.map((item, i) => {
										return (
											<option key={i} value={item.name}>{item.name}</option>
										)
									})
									: ""
							}
						</select>
					</div>

					<div className="col-6 mt-1 mb-1">
						<label className="form-label" style={{ fontSize: "12px" }}>{STR_STREET[appContext.language]}</label>
						<select
							className="form-control"
							onChange={(e) => {
								setStreet(e.target.value)
							}}
							value={street}
						>
							<option value=""></option>
							{
								(allStreets && allStreets.length > 0) ?
									allStreets.map((item, i) => {
										return (
											<option key={i} value={item.name}>{item.name}</option>
										)
									})
									: ""
							}
						</select>
					</div>

				</div>
			</div>
			
		</div>
	);
}
